<template>
  <el-carousel :interval="10000" type="card">
    <el-carousel-item v-for="(item,index) in this.certificatesList" :key="index">
      <img :src="item.address" class="imgShow"/>
    </el-carousel-item>
  </el-carousel>
</template>

<script>
    import axios from 'axios'

    export default {
        data() {
            return {certificatesList: []}
        },
        methods: {
            getImgList() {
                axios.get('/static/mock/certificatesList.json')
                    .then(this.getSucc);
            },

            getSucc(res) {
                res = res.data;
                const data = res.data;
                this.certificatesList = res.certificatesList;
            },
        },
        mounted() {
            this.getImgList();
        },
    }
</script>

<style scoped>
  .el-carousel {
    height: 720px;
  }

  .el-carousel >>> .el-carousel__container {
    height: 690px;
  }

  .el-carousel__item {
    text-align: center;
  }

  .el-carousel__item .is-active {
    box-shadow: 5px 5px 5px #0f59a4;
  }

  .imgShow {
    margin-top: 10px;
    height: 670px;
    box-shadow: 0 0 15px #000;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Technology/Components/SRability.vue